import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export interface ActivityRoleConfigurationDto {
  id: number;
  name: string;
  shortName?: string | null;
  description?: string | null;
  isActive: boolean;
  isDefault?: boolean;
}

export interface ActivityConfigurationDto {
  id: number;
  name: string;
  description?: string | null;
  areaId: number;
  areaCode: string;
  areaName: string;
  allowedOrganizationLevelIds: number[];
  allowedOrganizationLevelNames: string[];
  isActive: boolean;
  roles: ActivityRoleConfigurationDto[];
}

export interface UpsertActivityRoleConfigurationDto {
  id?: number | null;
  name: string;
  shortName?: string | null;
  description?: string | null;
  isActive: boolean;
  isDefault?: boolean;
}

export interface UpsertActivityConfigurationDto {
  name: string;
  description?: string | null;
  areaId: number;
  allowedOrganizationLevelIds: number[];
  isActive: boolean;
  roles: UpsertActivityRoleConfigurationDto[];
}

@Injectable({ providedIn: 'root' })
export class ActivityManagementService {
  private readonly apiUrl = `${environment.apiUrl}/activities`;

  constructor(private readonly http: HttpClient) {}

  getAll(): Observable<ActivityConfigurationDto[]> {
    return this.http.get<ActivityConfigurationDto[]>(this.apiUrl);
  }

  getById(id: number): Observable<ActivityConfigurationDto> {
    return this.http.get<ActivityConfigurationDto>(`${this.apiUrl}/${id}`);
  }

  create(dto: UpsertActivityConfigurationDto): Observable<ActivityConfigurationDto> {
    return this.http.post<ActivityConfigurationDto>(this.apiUrl, dto);
  }

  update(id: number, dto: UpsertActivityConfigurationDto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
